import getConfig from 'next/config';

export const B2cAndWebFavicons = () => {
    const { publicRuntimeConfig } = getConfig();
    const cdnUrl = publicRuntimeConfig.cdnUrl;
    const faviconsBaseUrl = `${cdnUrl}/favicons`;

    return (
        <>
            <link
                key="b2c-favicon-16x16"
                href={`${faviconsBaseUrl}/favicon-16x16.png`}
                rel="icon"
                sizes="16x16"
                type="image/png"
            />
            <link
                key="b2c-favicon-32x32"
                href={`${faviconsBaseUrl}/favicon-32x32.png`}
                rel="icon"
                sizes="32x32"
                type="image/png"
            />
            <link
                key="b2c-favicon-96x96"
                href={`${faviconsBaseUrl}/favicon-96x96.png`}
                rel="icon"
                sizes="96x96"
                type="image/png"
            />
            <link key="b2c-favicon-ico" href={`${faviconsBaseUrl}/favicon.ico`} rel="icon" sizes="any" />
            <link
                key="b2c-android-icon-36x36"
                href={`${faviconsBaseUrl}/android-icon-36x36.png`}
                rel="icon"
                sizes="36x36"
                type="image/png"
            />
            <link
                key="b2c-android-icon-48x48"
                href={`${faviconsBaseUrl}/android-icon-48x48.png`}
                rel="icon"
                sizes="48x48"
                type="image/png"
            />
            <link
                key="b2c-android-icon-72x72"
                href={`${faviconsBaseUrl}/android-icon-72x72.png`}
                rel="icon"
                sizes="72x72"
                type="image/png"
            />
            <link
                key="b2c-android-icon-96x96"
                href={`${faviconsBaseUrl}/android-icon-96x96.png`}
                rel="icon"
                sizes="96x96"
                type="image/png"
            />
            <link
                key="b2c-android-icon-144x144"
                href={`${faviconsBaseUrl}/android-icon-144x144.png`}
                rel="icon"
                sizes="144x144"
                type="image/png"
            />
            <link
                key="b2c-android-icon-192x192"
                href={`${faviconsBaseUrl}/android-icon-192x192.png`}
                rel="icon"
                sizes="192x192"
                type="image/png"
            />
            <link key="b2c-apple-touch-icon" href={`${faviconsBaseUrl}/apple-touch-icon.png`} rel="apple-touch-icon" />
            <link
                key="b2c-apple-icon-57x57"
                href={`${faviconsBaseUrl}/apple-icon-57x57.png`}
                rel="apple-touch-icon"
                sizes="57x57"
            />
            <link
                key="b2c-apple-icon-60x60"
                href={`${faviconsBaseUrl}/apple-icon-60x60.png`}
                rel="apple-touch-icon"
                sizes="60x60"
            />
            <link
                key="b2c-apple-icon-72x72"
                href={`${faviconsBaseUrl}/apple-icon-72x72.png`}
                rel="apple-touch-icon"
                sizes="72x72"
            />
            <link
                key="b2c-apple-icon-76x76"
                href={`${faviconsBaseUrl}/apple-icon-76x76.png`}
                rel="apple-touch-icon"
                sizes="76x76"
            />
            <link
                key="b2c-apple-icon-114x114"
                href={`${faviconsBaseUrl}/apple-icon-114x114.png`}
                rel="apple-touch-icon"
                sizes="114x114"
            />
            <link
                key="b2c-apple-icon-120x120"
                href={`${faviconsBaseUrl}/apple-icon-120x120.png`}
                rel="apple-touch-icon"
                sizes="120x120"
            />
            <link
                key="b2c-apple-icon-144x144"
                href={`${faviconsBaseUrl}/apple-icon-144x144.png`}
                rel="apple-touch-icon"
                sizes="144x144"
            />
            <link
                key="b2c-apple-icon-152x152"
                href={`${faviconsBaseUrl}/apple-icon-152x152.png`}
                rel="apple-touch-icon"
                sizes="152x152"
            />
            <link
                key="b2c-apple-icon-180x180"
                href={`${faviconsBaseUrl}/apple-icon-180x180.png`}
                rel="apple-touch-icon"
                sizes="180x180"
            />
            <link
                key="b2c-apple-icon-precomposed"
                href={`${faviconsBaseUrl}/apple-icon-precomposed.png`}
                rel="apple-touch-icon-precomposed"
            />
            <link
                key="b2c-safari-pinned-tab"
                color="#5bbad5"
                href={`${faviconsBaseUrl}/safari-pinned-tab.svg`}
                rel="mask-icon"
            />
            <link key="b2c-site-webmanifest" href={`${faviconsBaseUrl}/site.webmanifest`} rel="manifest" />
            <meta
                key="b2c-browserconfig-xml"
                content={`${faviconsBaseUrl}/browserconfig.xml`}
                name="msapplication-config"
            />
            <meta
                key="b2c-mstile-150x150"
                content={`${faviconsBaseUrl}/mstile-150x150.png`}
                name="msapplication-TileImage"
            />
        </>
    );
};
